<template>
    <ayuda-tema-base
        :busqueda="busqueda"
        :color="color"
        :faqs="faqs"
        :video-url="videoUrl"
        :video-titulo="$t('mensajes.central_reservas.ayuda_contenido.titulo')"
    />
</template>

<script>
import AyudaTemaBase from './AyudaTemaBase.vue';

export default {
    name: 'AyudaTemaGeneral',
    components: {
        AyudaTemaBase
    },
    props: {
        busqueda: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#455A64'
        }
    },
    computed: {
        videoUrl() {
            const videosPorIdioma = {
                es: 'https://share.synthesia.io/embeds/videos/908357a4-6c14-4eec-9ee1-c64565b9a452',
                en: 'https://share.synthesia.io/embeds/videos/43233b0a-73a9-4d09-be25-eeeb305f723d',
                de: 'https://share.synthesia.io/embeds/videos/6de3639f-91c3-4c2b-bd43-c97a2aa874e4'
            };

            return videosPorIdioma[this.$i18n.locale] || videosPorIdioma.es;
        },
        faqs() {
            return [
                {
                    id: 1,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.general.1.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.general.1.respuesta')
                },
                {
                    id: 2,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.general.2.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.general.2.respuesta')
                },
                {
                    id: 3,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.general.3.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.general.3.respuesta')
                }
            ];
        }
    }
};
</script>
